<template>
  <div class="left-sidebar col-md-2">
    <router-link active-class="active" exact :to="{ name: 'report-list' }">
      Select a Report
    </router-link>
    <a v-bind:href="adminURL" target="_blank">Admin</a>
    <br />

    <router-link
      active-class="active"
      exact
      :to="{ name: 'social_security_calc' }"
    >
      Social Security Calcs
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'other_calc' }">
      Other Calcs
    </router-link>

    <router-link
      active-class="active"
      exact
      :to="{ name: 'dc_contribution_calc' }"
    >
      DC Contribution Calcs
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'dc_balances_calc' }">
      DC Balances
    </router-link>

    <router-link
      active-class="active"
      exact
      :to="{ name: 'social_security_taxable_calc' }"
    >
      Social Security Taxable Calcs
    </router-link>

    <router-link
      active-class="active"
      exact
      :to="{ name: 'state_retirement_taxes_calc' }"
    >
      state_retirement_taxes
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'state_tax_calc' }">
      State Tax Calcs
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'input_fields' }">
      Input Fields
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'contribution_calc' }">
      Contribution Calcs
    </router-link>

    <router-link
      active-class="active"
      exact
      :to="{ name: 'output_fields_calc' }"
    >
      Output Fields
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'annual_costs' }">
      Annual Costs Calcs
    </router-link>

    <router-link active-class="active" exact :to="{ name: 'sso-login' }">
      SSO login
    </router-link>
  </div>
</template>

<style lang="scss" scoped>
.left-sidebar {
  background-color: white;
  padding: 20px 10px 10px 20px;
  font-size: 13px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  a {
    color: black !important;
    display: block;
    padding: 5px;
  }

  a.active {
    color: #c97837 !important;
    font-size: 16px;
  }
}

.left-sidebar a.active:before {
  content: ">";
  position: absolute;
  margin-left: -12px;
}
</style>

<script>
export default {
  name: "RoeHeader",
  data() {
    return {
      adminURL: `${process.env.VUE_APP_API_BASE_URL}/admin`
    };
  }
};
</script>
